import React, {useEffect, useState} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {Outlet, useNavigate, useParams} from 'react-router-dom'

import {getKnowledgebase} from 'actions'
import {CREATE_KNOWLEDGEBASE, GET_DOC_DETAILS} from 'actions/types'
import KBMenu from 'navigation/sub-routes/Knowledgebase/KBMenu'
import useKnowledgebase from 'hooks/pure/useKnowledgebase'
import {KNOWLEDGEBASE_PATH} from 'constants/path'
import CreateKnowledgebase from './CreateKnowledgebase'

export default function Knowledge() {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const {id} = useParams()

  const [iscreateModalOpen, setIsCreateModalOpen] = useState(false)

  const {setKnowledgeBaseId, setKnowledgeBaseName} = useKnowledgebase()

  const {successLabels = []} = useSelector(state => state.apiReducer)
  const {docDetails} = useSelector(state => state.knowledgebase)
  const kbName = docDetails?.name

  useEffect(() => {
    dispatch(getKnowledgebase())
  }, [dispatch])

  useEffect(() => {
    if (successLabels.includes(CREATE_KNOWLEDGEBASE)) {
      navigate(`/${KNOWLEDGEBASE_PATH.PREFIX}`)
      dispatch(getKnowledgebase())
    }
  }, [successLabels, navigate, dispatch])

  useEffect(() => {
    if (id) {
      setKnowledgeBaseId(id)
    }
  }, [id, setKnowledgeBaseId])

  useEffect(() => {
    if (successLabels.includes(GET_DOC_DETAILS)) {
      if (kbName) setKnowledgeBaseName(kbName)
    }
  }, [successLabels, kbName, setKnowledgeBaseName])

  return (
    <>
      {iscreateModalOpen && <CreateKnowledgebase open={iscreateModalOpen} toggle={setIsCreateModalOpen} />}
      <KBMenu iscreateModalOpen={iscreateModalOpen} setIsCreateModalOpen={setIsCreateModalOpen} />
      <div className="vmoSideBar-wrap">
        <Outlet />
      </div>
    </>
  )
}
